import React from "react";

function Controller() {
  console.log("testting");
  return (
    <div>
      <h1>Football API</h1>
    </div>
  );
}

export default Controller;
